import Label from "./Label";
import Text from "./Text";

import {
    getLocalizedSearchLabel,
    getLocalizedParamLabel,
    getLocalizedParamTitle,
} from "./utils";

const SearchParam = {
    Label,
    Text,
};

export {
    getLocalizedSearchLabel,
    getLocalizedParamLabel,
    getLocalizedParamTitle,
};

export default SearchParam;
